<div>
  <div class="dialog-heading">
    <h5>Select a Company</h5>
    <span class="flex-fill"></span>
    <mat-icon class="close-dialog" aria-hidden="false" mat-dialog-close aria-label="Close icon">close</mat-icon>
  </div>
  <mat-dialog-content>
    <p class="mat-body">
      We've found more precise company details. Please find our suggestion(s) below and confirm your company selection.
    </p>
    <div class="result-container">
      <div
        class="company-container"
        *ngFor="let org of organisations"
        (click)="selectedOrganisation = org"
        [ngStyle]="{
          borderColor: selectedOrganisation === org ? 'var(--accentColour)' : '#ccc',
          backgroundColor: selectedOrganisation === org ? 'var(--accentColour)' : 'white',
          color: selectedOrganisation === org ? 'white' : 'var(--primaryFontColour)'
        }"
      >
        <p *ngIf="org.primaryName">
          {{ org.primaryName }}
        </p>
        <p *ngIf="org.primaryAddress.streetAddress.line1">
          {{ org.primaryAddress.streetAddress.line1 }}
        </p>
        <p *ngIf="org.primaryAddress.streetAddress.line2">
          {{ org.primaryAddress.streetAddress.line2 }}
        </p>
        <p *ngIf="org.primaryAddress.postalCode">
          {{ org.primaryAddress.postalCode }}
        </p>
        <p *ngIf="org.primaryAddress.addressLocality.name">
          {{ org.primaryAddress.addressLocality.name }}
        </p>
        <p *ngIf="org.primaryAddress.addressRegion.abbreviatedName">
          {{ org.primaryAddress.addressRegion.abbreviatedName }}
        </p>
        <p *ngIf="org.primaryAddress.addressCountry.isoAlpha2Code">
          {{ org.primaryAddress.addressCountry.isoAlpha2Code }}
        </p>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="actions">
    <button
      id="confirmPrimaryBtn"
      mat-raised-button
      color="accent"
      [disabled]="!selectedOrganisation"
      [mat-dialog-close]="selectedOrganisation"
    >
      Confirm
    </button>
    <button mat-stroked-button color="accent" mat-dialog-close>Cancel</button>
  </mat-dialog-actions>
</div>
